/**
 * PUNTO DE ENTRADA PRINCIPAL - HANAMIPOS FRONTEND
 *
 * Este archivo es el punto de entrada de toda la aplicación Vue.js
 * Aquí configuramos y montamos la aplicación en el DOM
 */

// Imports principales de Vue.js 3
import { createApp } from 'vue'      // Función para crear la aplicación Vue
import { createPinia } from 'pinia'  // Pinia para manejo de estado global
import router from './router'        // Configuración de rutas

// Componente raíz de la aplicación
import App from './App.vue'

// Estilos CSS
import './assets/main.css'  // Estilos principales con Tailwind CSS

/**
 * CONFIGURACIÓN DE LA APLICACIÓN
 *
 * createApp() crea una nueva instancia de aplicación Vue
 * Cada aplicación Vue tiene su propio contexto aislado
 */
const app = createApp(App)

/**
 * PLUGINS Y CONFIGURACIÓN
 *
 * use() instala plugins en la aplicación
 * - Pinia: para estado global (como el usuario logueado, carrito, etc.)
 * - Router: para navegación entre páginas
 */

// Pinia - Gestión de estado global
// Permite compartir datos entre componentes de forma reactiva
app.use(createPinia())

// Vue Router - Navegación entre vistas
// Permite crear una SPA (Single Page Application) con múltiples rutas
app.use(router)

/**
 * CONFIGURACIÓN GLOBAL
 *
 * Podemos agregar propiedades globales que estarán disponibles
 * en todos los componentes
 */

// Variables de entorno accesibles globalmente
app.config.globalProperties.$env = {
  API_BASE_URL: import.meta.env.VITE_API_BASE_URL,
  APP_NAME: import.meta.env.VITE_APP_NAME,
  DEBUG: import.meta.env.VITE_DEBUG === 'true'
}

/**
 * MANEJO DE ERRORES GLOBAL
 *
 * Captura errores no manejados en componentes
 * Útil para debugging y logging
 */
app.config.errorHandler = (err, instance, info) => {
  console.error('Error global capturado:', err)
  console.error('Información del error:', info)

  // En producción, aquí enviarías el error a un servicio de logging
  if (import.meta.env.VITE_DEBUG === 'true') {
    console.error('Instancia del componente:', instance)
  }
}

/**
 * MONTAR LA APLICACIÓN
 *
 * mount('#app') busca el elemento con id="app" en index.html
 * y monta toda la aplicación Vue ahí
 */
app.mount('#app')

/**
 * INFORMACIÓN DE DESARROLLO
 *
 * Solo en modo debug, mostramos información útil en consola
 */
if (import.meta.env.VITE_DEBUG === 'true') {
  console.log('🚀 HanamiPOS Frontend iniciado')
  console.log('📡 API Base URL:', import.meta.env.VITE_API_BASE_URL)
  console.log('🔧 Modo desarrollo activo')
}